<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button type="button" (click)="backToPage()" title="Back">
        <ion-icon name="chevron-back-outline"></ion-icon>&nbsp;Back
      </ion-button>
    </ion-buttons>
    <ion-title>
      <ion-icon name="accessibility"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Declaration</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  {{message}}
  <ion-list>
    <ion-list>
      <ion-item>
        <h1>Declaration</h1>
      </ion-item>
      <ion-item>
        <ion-label>Who Signs the Checklist?
          As the home club is responsible to ensure the greater environment of the venue is safe for members and guests,
          an authorised (18+ years of age) home club representative signs the form. As the away team players and
          entourage participate in the game under the same conditions, an authorised (18+ years of age) away team
          representative also signs the form. </ion-label>
      </ion-item>
      <ion-item></ion-item>
      <ion-item>
        <ion-checkbox [disabled]="accessibleMode==='VIEW'" [(ngModel)]="declarationInfo.weAreAuthorisedRepresentatives">
          <div class="ion-text-wrap">I / We declare that I / We are authorised representatives of the nominated Teams
          </div>
        </ion-checkbox>
      </ion-item>
      <ion-item>
        <ion-checkbox [disabled]="accessibleMode==='VIEW'" id="isDeclareThat" name="isDeclareThat"
          [(ngModel)]="declarationInfo.weDeclareThatAfterReasonableInquiry" [required]="true" #isDeclareThat="ngModel">
          <div class="ion-text-wrap">I / We declare that after reasonable inquiry, the following statements are true and
            accurate</div>
        </ion-checkbox>
      </ion-item>
      <ion-item *ngIf="isDeclareThat.invalid && isDeclareThat.touched">
        <ion-text color="danger">This is required</ion-text>
      </ion-item>
      <ion-item>
        <ion-checkbox [disabled]="accessibleMode==='VIEW'" id="isInspectionMatchDay" name="isInspectionMatchDay"
          [(ngModel)]="declarationInfo.inspectionMatchDayChecklistCompleted" [required]="true"
          #isInspectionMatchDay="ngModel">
          <div class="ion-text-wrap">
            <p>A. the above inspection (Match Day Checklist) was completed as per the above date and time<br>
              B. all hazards, risks and safety concerns have been addressed to an acceptable level and recorded on this
              form (Sec. 5)<br>
              C. both teams are satisfied that the playing conditions are acceptable prior to the commencement of play
            </p><br>
          </div>
        </ion-checkbox>
      </ion-item>
      <ion-item *ngIf="isInspectionMatchDay.invalid && isInspectionMatchDay.touched">
        <ion-text color="danger">This is required</ion-text>
      </ion-item>
      <!-- <ion-item *ngIf="accessibleMode!=='VIEW'">
        <div id="recaptcha"></div>
      </ion-item> -->
      <ion-item></ion-item>
      <ion-item>
        <label>Home Team Representative : {{declarationInfo.homeTeamRepresentativeName}}</label>
      </ion-item>
      <ion-item>
        <label>Position : {{declarationInfo.homeTeamRepresentativePosition}}</label>
      </ion-item>
      <ion-item>
        <label>Away Team Representative : {{declarationInfo.awayTeamRepresentativeName}}</label>
      </ion-item>
      <ion-item>
        <label>Position : {{declarationInfo.awayTeamRepresentativePosition}}</label>
      </ion-item>
      <ion-item>
        <label>Submission Date Time: {{declarationInfo.submissionDateTime}}</label>
      </ion-item>
      <ion-item></ion-item>
      <ion-item>
        <ion-label>Marsh recommend a copy of this Game Day Checklist is retained on file for seven (7) years by the
          home/away teams.</ion-label>
      </ion-item>
      <ion-item class="transparent-background" *ngIf="accessibleMode!=='VIEW'">
        <ion-grid>
          <ion-row>
            <ion-col class="text-align-right border-none">
              <ion-button [disabled]="declarationInfo.weAreAuthorisedRepresentatives == false 
                || declarationInfo.weDeclareThatAfterReasonableInquiry == false 
                || declarationInfo.inspectionMatchDayChecklistCompleted == false" 
                type="button"
                expand="block" 
                (click)="submitDeclartion()" item-right>Submit</ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>
    </ion-list>
  </ion-list>